import img1 from "./../../assets/logo/crop-light.png";

export const SponsorsData = [
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    {
        index: 0,
        img: img1,
        name: "Google",
    },
    
]